import { CustomFieldFilter } from '../types/product-custom-fields'

/**
 * Trims field text using the API's Unicode whitespace rules.
 * @param {string} value Field name or value entered by the user.
 * @returns {string} Text with leading and trailing whitespace removed.
 */
export function trimCustomFieldText(value: string): string {
  return value.replace(/^\p{White_Space}+|\p{White_Space}+$/gu, '')
}

/**
 * Builds the same case-insensitive field identity as the API.
 * Go lowercases each code point independently and maps dotted İ to plain i.
 * @param {string} value Field name or unit to compare.
 * @returns {string} Trimmed, lowercase identity.
 */
export function normalizeCustomFieldIdentity(value: string): string {
  return Array.from(trimCustomFieldText(value), (character) => {
    if (character === 'İ') return 'i'
    return character.toLowerCase()
  }).join('')
}

/**
 * Serializes active attribute filters for the marketplace query.
 * Empty controls and the UI's field keys are omitted.
 * @param {CustomFieldFilter[]} fields Selected attribute filters.
 * @returns {string} JSON containing the filter properties accepted by the API.
 */
export function serializeCustomFieldFilters(
  fields: CustomFieldFilter[],
): string {
  const activeFields = fields.filter(
    (field) =>
      (field.values?.length ?? 0) > 0 || field.min != null || field.max != null,
  )
  return JSON.stringify(
    activeFields.map((field) => ({
      name: field.name,
      type: field.type,
      unit: field.unit,
      values: field.values,
      min: field.min,
      max: field.max,
    })),
  )
}
